<template>
    <v-input
        :value="innerValue"
        :rules="normalizedRules"
        class="mt-0 pt-0 checkbox-group-field"
    >
        <v-row :class="rowClass">
            <v-col
                v-for="(item, index) in items"
                :key="item[valueKey] || index"
                cols="12"
                :md="mdCols"
                class="py-0"
            >
                <v-checkbox
                    v-model="innerValue"
                    :label="item[labelKey]"
                    :value="item[valueKey]"
                    class="ma-0"
                    hide-details
                />
            </v-col>
        </v-row>
    </v-input>
</template>

<script>
    export default {
        name: 'CheckboxGroupField',
        props: {
            value: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            rules: {
                type: [Array, Function],
                default: () => []
            },
            mdCols: {
                type: [Number, String],
                default: 4
            },
            rowClass: {
                type: String,
                default: ''
            },
            labelKey: {
                type: String,
                default: 'label'
            },
            valueKey: {
                type: String,
                default: 'value'
            }
        },
        computed: {
            innerValue: {
                get () {
                    return Array.isArray(this.value) ? this.value : []
                },
                set (val) {
                    this.$emit('input', val)
                }
            },
            normalizedRules () {
                const flattenedRules = this.flattenRules(this.rules)
                return flattenedRules.filter(rule => typeof rule === 'function' || typeof rule === 'string')
            }
        },
        methods: {
            flattenRules (rules) {
                if (!Array.isArray(rules)) {
                    return [rules]
                }

                return rules.reduce((acc, rule) => acc.concat(this.flattenRules(rule)), [])
            }
        }
    }
</script>

<style scoped>
.checkbox-group-field.error--text /deep/ .v-label,
.checkbox-group-field.v-input--has-state.error--text /deep/ .v-label {
    color: #ff5252 !important;
}

.checkbox-group-field.error--text /deep/ .v-input--checkbox .v-icon,
.checkbox-group-field.v-input--has-state.error--text /deep/ .v-input--checkbox .v-icon {
    color: #ff5252 !important;
}
</style>
